import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PageTitle, successToast, MDTAlertBanner } from 'mdt-core-components';
import { withTranslation } from 'react-i18next';
import { Row, Col, Container } from 'reactstrap';
import { MDTApi } from 'mdt-core-components/src/services/mdtapi.js';
import { MDTApp } from 'mdt-core-components/src/actions/bootAction.js';
import { featureConfiguration } from 'mdt-core-components/src/actions/MeActions.js';
import Constants from 'mdt-core-components/src/helpers/constants.js';
import { sendEventTrackingData } from 'mdt-core-components/src/helpers/commonUtils.js';
import { AnalyticsConstants } from 'mdt-core-components/src/helpers/analyticsConstants.js';
import _ from 'lodash';

import jwt_decode from 'jwt-decode';
import UserLogin from './user-login.js';

import {
  getResourceRights,
  getResourceRightsSuccess,
  stateUpdate,
} from 'mdt-core-components/src/actions/MeActions.js';
import './login.css';

export class Login extends Component {
  constructor(props) {
    super(props);
    this.submitLoginInfo = this.submitLoginInfo.bind(this);
    this.handleResponseData = this.handleResponseData.bind(this);
    this.handleErrorResponse = this.handleErrorResponse.bind(this);
    this.medtronicEmailValidation = this.medtronicEmailValidation.bind(this);
    this.state = {
      disabledUser:false,
      loginError: false,
      severErrorMsg: '',
      registerMessageEnabled: MDTApp.getSetting(
        'features.registerMessageEnabled'
      )
    };
  }
  componentDidMount() {
    const { location } = this.props;
    if (
      location &&
      location.payload &&
      location.payload.reset &&
      location.payload.reset !== ''
    ) {
      successToast(location.payload.reset);
    }
  }
  tabClickHandle(event, currentTab) {}

  dataMapping(param) {
    var str = [];
    for (var p in param)
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(param[p]));
    return str.join('&');
  }

  submitLoginInfo(param) {
    this.setState({ loginError: false, severErrorMsg: '' });

    MDTApi.call('api.login.getToken', {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      data: this.dataMapping(param),
      successCallback: this.handleResponseData,
      errorCallback: this.handleErrorResponse,
    });
  }
  handleResponseData(data) {
    const { userDetails: { isInternal } } = this.props;
    const userType = isInternal === 'True' ? AnalyticsConstants.categories['internal'] : AnalyticsConstants.categories['external'];
    const dateTime = new Date().toJSON();
    const trackingLabel = `Login_${userType} : ${dateTime}`;
    const eventParamObj = {
      eventCategory: 'accManagement',
      eventAction: 'login',
      eventLabel: trackingLabel,
      processLabels: false,
    };
    sendEventTrackingData(eventParamObj);

    //decode token to check password
    const decodedToken = jwt_decode(data.access_token);
    const depthURL = sessionStorage.getItem('depthURL') || '';
    const SSOclick = !!decodedToken.sso && decodedToken.sso === 'True';
    this.props.refreshToken(data);
    if (
      !!decodedToken.ApplyOnBoarding &&
      decodedToken.ApplyOnBoarding === 'true'
    ) {
      this.props.redirectToAccountSetup();
    } else if (depthURL !== '' && !depthURL.includes('/login')) {
      // to check only whitelist urls will get redirected
      const claimApps = _.mapValues(decodedToken.app, function(val) {
        if (typeof val === 'string') {
          return val.toLowerCase();
        }
      });
      const fetchApp = depthURL.split('/apps/');
      let appName = fetchApp[1];
      const splitApp = appName.split('/'),
        whiteListUrl = window.MDTSetting.whiteListUrl;

      appName = `${window.MDTSetting.pathVars.buid}/${splitApp[0]}`;

      const shouldRedirect = _.includes(claimApps, appName.toLowerCase());
      let whiteListCheck = false;
      _.forEach(whiteListUrl, function(value) {
        const matchString = splitApp[1].match(value);
        if (matchString != null) {
          whiteListCheck = true;
        }
      });
      if (shouldRedirect && whiteListCheck) {
        window.location = depthURL;
        sessionStorage.setItem('depthURL', '');
      } else {
        this.props.redirectTo('PORTAL');
      }
    } else if (
      !!decodedToken.appLink &&
      decodedToken.appLink !== '' &&
      !SSOclick &&
      decodedToken.password !== 'must_change_now'
    ) {
      window.location = decodedToken.appLink;
    } else {
      this.props.redirectTo('PORTAL');
    }

    // NOTE: This will load the configurations of the portal app after the login happens,
    // this call happens originally in the initBootstrap function but that only gets
    // triggered once per app initialization  20220628:Alevale
    this.props.loadConfigurations();
  }
  medtronicEmailValidation(loginError, msg) {
    //let msg = "Please utilize your Medtronic network ID instead of email address and log in again";
    this.setState({ loginError, severErrorMsg: msg });
  }

  //TODO: Code cleanup required - Error Description should be a CMS key. Currenty error description is being used directly from api

  handleErrorResponse(error) {
    const { t } = this.props;
    let msg = t('loginError');
    if(error && error.data && error.data.error_description === 'errorDisabledUser'){
      this.setState({
        disabledUser: true
      })
      const eventParamObj = {
        eventCategory: 'error',
        eventAction: 'loginError',
        eventLabel: 'restrictedUser',
      };
      sendEventTrackingData(eventParamObj);
    } else {

      if (error && error.data && error.data.error_description) {
        msg = error.data.error_description;
      }
      this.setState({ disabledUser:false, loginError: true, severErrorMsg: msg });
    }
  }
  render() {
    const { t } = this.props;
    const { registerMessageEnabled } = this.state;
    const loginOptions = {
      submitLoginInfo: this.submitLoginInfo,
      medtronicEmailValidation: this.medtronicEmailValidation,
    };

    const disabledUserProps = {
      type: 'warning',
      title:  t('disabledUserTitle'),
      children: <div  dangerouslySetInnerHTML={{ __html: t('disabledUserMessage')} }/>
    }

    const bannerProps = {
      type: 'warning',
      title: t('preLoginTitle', ''),
      children: t('preLoginMessage', '')
    }

    return (
      <div>
        <Container className="login-page-container">
          <Row>
            <Col xs={12} className="no-gutter-tablet">
              <PageTitle title={t('login.title')} />
            </Col>
          </Row>
          <Row>
            <Col className="login-page">
            {registerMessageEnabled && (
              <Col className="login-page-qrcode">
                <Row xs='1'>
                  <Col>
                    <img className="qrcode_image"></img>
                  </Col>
                  <Col><h5 className="p-active">{t('login.qrcode')}</h5></Col>
                  <Col className='qrcode_text'><h5 className="p-active">{t('login.qrcodetext')}</h5></Col>
                </Row>
              </Col>)}
              <Row>
                <Col xs={12} className="body2 text-center logintext">
                  <h2 className="p-active">{t('login.subtitle')}</h2>
                </Col>

                {(this.state.disabledUser && disabledUserProps.title && disabledUserProps.children) &&
                  <Col xs={12} >
                    <div className='pre-login-message elevation-1'>
                      <MDTAlertBanner {...disabledUserProps} />
                    </div>
                  </Col>
                }
                {(bannerProps.title && bannerProps.children) &&
                  <Col xs={12} >
                    <div className='pre-login-message elevation-1'>
                      <MDTAlertBanner {...bannerProps} />
                    </div>
                  </Col>
                }

                <div className="information-message">
                  <div
                    dangerouslySetInnerHTML={{ __html: t('informationBanner') }}
                  />
                </div>
                {this.state.loginError && (
                  <Col xs={12} className="body2 error text-center">
                    {this.state.severErrorMsg}
                  </Col>
                )}
                <Col xs={12}>
                  <div className="login-from-sec">
                    <UserLogin loginOptions={loginOptions} />
                  </div>
                </Col>
                {registerMessageEnabled && (
                  <Col xs={12} className="login-internet-register">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: t('login.registerMessage'),
                      }}
                    />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    location: state.location || {},
    userDetails: state.meDetails || {},
    tokenEndpoint: state.meDetails.openIdConfig.token_endpoin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    redirectTo: (page, data) => {
      getResourceRights('api.login.resourceRights').then(resData => {
        dispatch(getResourceRightsSuccess(resData));
        dispatch(
          stateUpdate({
            FETCHING_RESOURCE_RIGHTS: false,
            HAS_RESOURCE_RIGHTS: true,
          })
        );
      });
      dispatch({ type: page, payload: { filter: data } });
    },
    redirectToAccountSetup: () => {
      dispatch({ type: 'ACCOUNTSETUP' });
    },
    loadConfigurations: () => {
      dispatch(featureConfiguration())
    },
    refreshToken: data => dispatch(MDTApp.setLoginData(data)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Login));
